import App from './App';
import { connect } from './connect';

export default connect(App);
